import React, { useState, useEffect } from "react";
import LeaveTable from "./components/LeaveTable";
import { connect } from "react-redux";
import SummaryHeader from "components/header/SummaryHeader";
import SummaryItem from "components/header/SummaryItem";
import { ClipboardList, FilePlusCorner, Plane, ScanHeart, UserLock,  } from "lucide-react";
import LeaveForm from "./components/LeaveForm";
import PopupButton from "components/button/PopupButton";
import { MODULE_LEAVE, DATE_FORMAT } from "variables/constants";
import { DatePicker } from "antd";
import {
	getLeaveBalance
} from "../../../redux/overview/overviewState";

const { RangePicker } = DatePicker;

const Leaves = ({
	leaveBalance,
	doGetBalance
}) => {
	const [dateRange, setDateRange] = useState(null);

	useEffect(() => {
		doGetBalance();
	}, [doGetBalance]);

	return (
	    <div className="space-y-6">
			<SummaryHeader
				title="Leave History"
				icon={ClipboardList}
				description="View your past and pending leave requests"
				color={"cyan"}
        		rightNav={
							<PopupButton 
								id="add_leave" 
								title="Request Leave"
								description="Submit a new leave request"
								label="Request Leave" 
								btnClass="btn-leave" 
								action="add"
								moduleId={MODULE_LEAVE}
								icon={FilePlusCorner}
								useCustomClass={true}
							>
								<LeaveForm recordId="0" mode="edit"/>
							</PopupButton>
				}
			>
                    <div className="summary-item-container">
                        {leaveBalance.map((item,index)=>(
							<SummaryItem
								key={item.code}
								title={item.title}
								icon={
									index === 0 
									? <Plane />
									: index === 1 
									? <ScanHeart />
									: <UserLock />
								}
								display={
									<div className="flex items-center gap-2">
										<p className="text-xl font-bold">
											{item?.used}
										</p>

										<p className="text-xs">
											of {item?.total} remaining
										</p>
									</div>
								}
							/>

						))}
                    </div>
			</SummaryHeader>
			<div className="mt-5 w-full md:w-1/2 max-w-[350px]">
				<RangePicker
					format={DATE_FORMAT}
					onChange={(dates) => setDateRange(dates)}
					className="input-field"
					allowClear
				/>
			</div>
			<div className="p-4 border rounded-2xl">
				<LeaveTable dateRange={dateRange}/>
			</div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
	leaveBalance: state.overview?.teamLeaveBalance?.data,
});

const mapDispatchToProps = (dispatch) => ({
	doGetBalance: () => dispatch(getLeaveBalance()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Leaves);